<template>
  <component :is="as" class="flex">
    <slot/>
  </component>
</template>

<script>
export default {
  name: 'Flex',
  props: {
    as: {
      type: String,
      default: 'div'
    }
  }
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
